import type { CurrencyProfile } from '@tg/shared';
import type { Messages } from '@/i18n/messages';

/** Explicit localized variants; do not replace arbitrary text or slot-symbol names at runtime. */
export function currencyMessages(base: Messages, profile: CurrencyProfile): Messages {
  if (!profile.enabled) return base;
  const messages = { ...base };
  const prefix = 'currency.text.';
  for (const [key, value] of Object.entries(base))
    if (key.startsWith(prefix)) {
      messages[key.slice(prefix.length)] = value.replaceAll('{currency}', profile.ticker);
    }
  return messages;
}
